export default __webpack_public_path__ + "static/media/tab02.ef44fa37.png";